import DomainError from "domain/error/DomainError";
import { PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider as BaseQueryClientProvider } from "react-query";
import UIErrorEvent from "ui/error/UIErrorEvent";
import { authSessionService } from "features/auth/services/authSessionService";

function handleQueryClientError(error: unknown): void {
    if (!authSessionService.userIsLoggedIn()) return;

    if (error instanceof DomainError) {
        UIErrorEvent.dispatch(error.code, error.severity);
    } else if (
        typeof error === "object" &&
        error !== null &&
        "message" in error &&
        typeof (error as Record<string, unknown>).message === "string"
    ) {
        UIErrorEvent.dispatch((error as { message: string }).message);
    } else {
        UIErrorEvent.dispatch("Unexpected error");
    }
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: 600000,
            onError: handleQueryClientError,
        },
        mutations: {
            onError: handleQueryClientError,
        },
    },
});

const QueryClientProvider = ({ children }: PropsWithChildren): JSX.Element => {
    return <BaseQueryClientProvider client={queryClient}>{children}</BaseQueryClientProvider>;
};

export default QueryClientProvider;
